import BaseApi from '../baseApi';
import baseApi from "@/api/baseApi";

export default {
  create(form) {
    return BaseApi.put(`/api-article/v1/accounting-package`, form);
  },

  async fetchTodo() {
    return await BaseApi.get('/api-article/v1/accounting-package')
  },
  requestDownload(packageId) {
    return baseApi.get(`/api-article/v1/accounting-package/request-download/${packageId}`);
  },
}


